import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-save-confirmation',
  templateUrl: './save-confirmation.component.html',
  styleUrls: ['./save-confirmation.component.scss']
})
export class SaveConfirmationComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<SaveConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  closeDialog(){
    this.dialogRef.close({event:'cancel'});
  }
  confirm(){
    this.dialogRef.close({event:'confirmed'});
  }


}
